    <div class="container">

        <h1>Radera dina uppgifter från Fototävling</h1>

 

        <div class="info-box">

            <p><strong>Vad raderas?</strong></p>

            <p>När du begär borttagning raderar vi följande uppgifter:</p>

            <ul>

                <li>Ditt namn</li>

                <li>Din e-postadress</li>

                <li>Ditt konto i Fototävling</li>

            </ul>

        </div>

 

        <h2>Så här raderar du dina uppgifter</h2>

       

        <ol>

            <li><span class="step">Skicka ett e-postmeddelande</span> till:</li>

        </ol>

 

        <div class="email-box">

            <p><strong>E-postadress:</strong> erik at kvarnbrannaby punkt se</p>

            <p><strong>Ämnesrad:</strong> Radera mitt konto</p>

        </div>

 

        <ol start="2">

            <li><span class="step">Ange följande information</span> i ditt meddelande:

                <ul>

                    <li>Ditt fullständiga namn</li>

                    <li>Den e-postadress du använder i Fototävling</li>

                </ul>

            </li>

            <li><span class="step">Vi bekräftar</span> din begäran via e-post</li>

            <li><span class="step">Dina uppgifter raderas</span> inom 30 dagar</li>

        </ol>

 

        <div class="warning-box">

            <p><strong>⚠️ Observera:</strong></p>

            <p>När dina uppgifter har raderats kan du inte återställa ditt konto eller dina uppgifter. Radering är permanent.</p>

        </div>

 

        <h2>Vanliga frågor</h2>

       

        <p><strong>Hur lång tid tar det?</strong><br>

        Vi raderar dina uppgifter inom 30 dagar från din begäran.</p>

 

        <p><strong>Får jag en bekräftelse?</strong><br>

        Ja, du får ett bekräftelsemail när vi har tagit emot din begäran och ett nytt meddelande när raderingen är klar.</p>

 

        <p><strong>Vad händer med mina bilder i tävlingar?</strong><br>

        Dina uppladdade bilder i aktiva tävlingar kan behöva hanteras separat. Kontakta oss för specifik information.</p>

 

        <p><strong>Kan jag skapa ett nytt konto senare?</strong><br>

        Ja, du kan när som helst skapa ett nytt konto med samma e-postadress.</p>

 

        <h2>Kontakt</h2>

        <p>Vid frågor om borttagning av uppgifter, kontakta oss på:<br>

        <strong>erik at kvarnbrannaby punkt se</strong></p>

 

        <div class="footer">

            <p>Fototävling följer GDPR och respekterar din rätt till radering av personuppgifter.</p>

        </div>

    </div>

